import { SINGLE_SCAN_FAILURE, SINGLE_SCAN_REQUEST, SINGLE_SCAN_SUCCESS } from "../constants/singleScanConstants";

export const singleScanRequest = (oemId, search = '', userType = '') => ({
  type: SINGLE_SCAN_REQUEST,
  payload: { oemId, search, userType }
});

export const singleScanSuccess = (data) => ({
  type: SINGLE_SCAN_SUCCESS,
  payload: data
});

export const singleScanFailure = (error) => ({
  type: SINGLE_SCAN_FAILURE,
  payload: error
});